import { GetSellerServicesBySellerIdRequest } from "./request"
import { GetSellerServicesBySellerIdResponse } from "./response"
import type { SellerServicesRepository } from "../../../repositories/sellerServicesRepository"
import { UseCase } from "../../useCase"

export class GetSellerServicesBySellerIdUseCase
	implements UseCase<GetSellerServicesBySellerIdRequest, GetSellerServicesBySellerIdResponse>
{
	private _repository
	constructor({ SellerServicesRepository }: { SellerServicesRepository: SellerServicesRepository }) {
		this._repository = SellerServicesRepository
	}

	exec(sellerId: GetSellerServicesBySellerIdRequest) {
		return this._repository.getServicesBySellerId(sellerId)
	}
}
